import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Typography, Box, CircularProgress, Link as MuiLink } from "@mui/material";
import { fetchNews, selectNews } from "../../store/slices/newsSlice";
import { AppDispatch, RootState } from "../../store/store";
import classes from "./TodaysNews.module.scss";

const TodaysNews: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { items, loading, error } = useSelector(selectNews);

    useEffect(() => {
        dispatch(fetchNews());
    }, [dispatch]);

    const renderContent = () => {
        if (loading) {
            return (
                <Box display="flex" justifyContent="center" my={2}>
                    <CircularProgress />
                </Box>
            );
        }

        if (error) {
            return (
                <Typography color="error" variant="body2" align="center">
                    {error}
                </Typography>
            );
        }

        if (items.length === 0) {
            return (
                <Typography variant="body2" align="center">
                    No news available at the moment.
                </Typography>
            );
        }

        return (
            <>
                {items.slice(0, 3).map((item, index) => (
                    <Box className={classes.newsItem} key={index}>
                        <MuiLink
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            <Typography className={classes.title} variant="body2">
                                {item.title}
                            </Typography>
                        </MuiLink>
                        <Typography className={classes.date} variant="caption">
                            {item.pubDate ? new Date(item.pubDate).toLocaleDateString() : ""}
                        </Typography>
                    </Box>
                ))}
                {items.length > 0 && (
                    <MuiLink
                        href="https://betakit.com/tag/jobs/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${classes.link}`}
                    >
                        Read more
                    </MuiLink>
                )}
            </>
        );
    };

    return (
        <div className={classes.newsSectionWrapper}>
            <Paper className={classes.newsSection}>
                <Typography variant="h6">Today&apos;s News</Typography>
                {renderContent()}
            </Paper>
        </div>
    );
};

export default TodaysNews;
